// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H28YDh {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  flex: 1;
  gap: 48px;
}

.T_jEDr {
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  height: 100%;
  flex: 1;
}

/* Tablet styles */
@media (max-width: 768px) {
  .H28YDh {
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .T_jEDr {
    gap: 16px;
    height: 100%;
  }
}

/* Mobile styles */
@media (max-width: 480px) {
  .T_jEDr {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    height: 100%;
  }
}

.nYuntE {
  width: 100%;
  height: 100%;
}

._4cr4R {
  min-width: 400px !important;
  max-width: 500px !important;
  width: auto !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/AreaPix/AreaPix.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,OAAO;AACT;;AAEA,kBAAkB;AAClB;EACE;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;IACT,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;AACxB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  gap: 48px;\n}\n\n.cardsGrid {\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n}\n\n/* Tablet styles */\n@media (max-width: 768px) {\n  .container {\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  .cardsGrid {\n    gap: 16px;\n    height: 100%;\n  }\n}\n\n/* Mobile styles */\n@media (max-width: 480px) {\n  .cardsGrid {\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.keysSection {\n  width: 100%;\n  height: 100%;\n}\n\n.pinErrorToast {\n  min-width: 400px !important;\n  max-width: 500px !important;\n  width: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `H28YDh`,
	"cardsGrid": `T_jEDr`,
	"keysSection": `nYuntE`,
	"pinErrorToast": `_4cr4R`
};
module.exports = ___CSS_LOADER_EXPORT___;
